// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license

/**
 * About n var in mash function
 * It’s just the fixed 32-bit IV (initial value) used by Baagøe’s Mash function in the Alea PRNG.
 * It “primes” the tiny hash so different input strings get mixed into a non-zero state.
 * The exact hex 0xEFC8249D isn’t mathematically special—any odd 32-bit constant would work—but this one became the de-facto value because it’s what the original Alea code shipped with.
 * Keeping it unchanged preserves compatibility/reproducibility with other Alea implementations.
 */

// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror/blob/master/support/js/Mash.js
function makeMash() {
	let n = 0xEFC8249D;

	return function mash(data: string) {
		data = String(data);
		for (let i = 0; i < data.length; i++) {
			n += data.charCodeAt(i);
			let h = 0.02519603282416938 * n;
			n = h >>> 0;
			h -= n;
			h *= n;
			n = h >>> 0;
			h -= n;
			n += h * 0x100000000; // 2^32
		}
		return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
	};
}

/* Why use this instead of a combination with Math.random() ?
- Reproducibility: In testing environments, you want the same output for the same inputs. A seeded generator ensures that.
- Debugging: If a bug appears in a random scenario, you can recreate it exactly.
- Portability: Share seeds across sessions or even different machines for consistent results.
- Control: Unlike true randomness (which is hard to achieve in code), seeded PRNGs are deterministic.
*/
export function deterministicSeed(seed: string) {
	const mash = makeMash();
	let c = 1;
	let s0 = mash(' ');
	let s1 = mash(' ');
	let s2 = mash(' ');

	s0 -= mash(seed);
	if (s0 < 0) {
		s0 += 1;
	}
	s1 -= mash(seed);
	if (s1 < 0) {
		s1 += 1;
	}
	s2 -= mash(seed);
	if (s2 < 0) {
		s2 += 1;
	}

	const t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
	s0 = s1;
	s1 = s2;
	s2 = t - (c = t | 0);

	return s2; // 0 <= s2 < 1
}
